import React from 'react';
import { Users, Briefcase } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const PlatformToggle = ({ currentMode, onToggle, businessNotifications }) => {
  return (
    <div className="flex items-center space-x-1 bg-white rounded-lg p-1 shadow-sm border border-gray-200">
      <Button
        variant={currentMode === 'social' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onToggle('social')}
        className={`flex items-center space-x-2 transition-all duration-200 px-3 py-2 rounded-md font-medium text-sm ${
          currentMode === 'social' 
            ? 'bg-blue-600 text-white shadow-sm' 
            : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
        }`}
      >
        <Users className="w-4 h-4" />
        <span>Social Network</span>
      </Button>
      
      <Button
        variant={currentMode === 'business' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onToggle('business')}
        className={`flex items-center space-x-2 transition-all duration-200 px-3 py-2 rounded-md font-medium text-sm relative ${
          currentMode === 'business' 
            ? 'bg-green-600 text-white shadow-sm' 
            : 'text-gray-600 hover:text-green-600 hover:bg-green-50'
        }`}
      >
        <Briefcase className="w-4 h-4" />
        <span>Business Hub</span>
        {businessNotifications > 0 && (
          <Badge 
            variant="destructive" 
            className="absolute -top-1 -right-1 px-1.5 py-0.5 text-[10px] min-w-[16px] h-[16px] flex items-center justify-center"
          >
            {businessNotifications}
          </Badge>
        )}
      </Button>
    </div>
  );
};

export default PlatformToggle;